import { ChangeDetectionStrategy, Component, inject, signal, WritableSignal } from '@angular/core';
import { OrIconComponent, PageLayoutComponent, TitileNavbarComponent } from '@ui-components';
import { Router } from '@angular/router';
import { AdminPanelRoutes, AppRoutes } from '@core';

@Component({
  selector: 'lib-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TitileNavbarComponent, PageLayoutComponent, OrIconComponent]
})
export class AdminHomeComponent {
  private readonly router: Router = inject(Router);
  usersExpanded: WritableSignal<boolean> = signal(false);
  gamesExpanded: WritableSignal<boolean> = signal(false);

  goToVersionInfo(): void {
    this.router.navigate([`${AppRoutes.ADMIN_PANEL}/${AdminPanelRoutes.VERSION_INFO}`]);
  }

  goToUsers(): void {
    this.router.navigate([`${AppRoutes.ADMIN_PANEL}/${AdminPanelRoutes.USERS}`]);
  }

  goToGames(): void {
    this.router.navigate([`${AppRoutes.ADMIN_PANEL}/${AdminPanelRoutes.GAMES}`]);
  }

  goToGeneratePost(): void {
    this.router.navigate([`${AppRoutes.ADMIN_PANEL}/${AdminPanelRoutes.GENERATE_POST}`]);
  }

  goToGamesStats(): void {
    this.router.navigate([`${AppRoutes.ADMIN_PANEL}/${AdminPanelRoutes.GAMES_STATS}`]);
  }

  goToUsersStats(): void {
    this.router.navigate([`${AppRoutes.ADMIN_PANEL}/${AdminPanelRoutes.USERS_STATS}`]);
  }

  goToFeatureFlags(): void {
    this.router.navigate([`${AppRoutes.ADMIN_PANEL}/${AdminPanelRoutes.FEATURE_FLAGS}`]);
  }
}
